import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";

/**
 * Drop-in replacement for react-auth-kit RequireAuth that avoids calling
 * doSignOut() during render (which causes infinite update loops on logout).
 */
function ProtectedRoute({ children, loginPath = "/login" }) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate to={loginPath} state={{ from: location }} replace />
    );
  }

  return children;
}

export default ProtectedRoute;
